import { Theme } from "@mui/material";
import { makeStyles } from "tss-react/mui";

export const useStyle = makeStyles()((theme: Theme) => ({
    aboutESimContent: {
        marginTop: theme.spacing(4),
    },
    aboutESimText: {
        marginTop: theme.spacing(2),
    },
    aboutESimItem: {
        textAlign: "center",
        marginBottom: theme.spacing(2),
    },
}));
